import { useBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client";
import {
    BitbucketWorkspacesResponse,
    BitbucketWorkspaceOptions
} from "@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types";

import { AsyncResult, useAsync } from "./use-async";

type UseBitbucketWorkspacesTypeOptions = {
    readonly makeRequest?: boolean;
} & BitbucketWorkspaceOptions;

export function useBitbucketWorkspaces({
    nextUrl,
    urlQuery,
    makeRequest
}: UseBitbucketWorkspacesTypeOptions): AsyncResult<BitbucketWorkspacesResponse | null> {
    const stargateClient = useBxpWebStargateClient();

    return useAsync(
        () =>
            makeRequest
                ? stargateClient.bitbucketWorkspaces({ nextUrl, urlQuery })
                : Promise.resolve(null),
        [makeRequest]
    );
}
